import React, { Fragment, useState } from 'react';
import VerificationTypeListBrowser from './VerificationTypeListBrowser';
import HeaderPortal from 'components/layout/HeaderPortal';
import HeaderLinks from '../components/header/HeaderLinks';
import Portal from 'utils/portal/Portal';
import PropTypes from 'prop-types';
import { areas } from 'constants/areas';
import { withAreaGetter } from 'providers/AreasConsumers';
import { useTranslation } from 'react-i18next';
import VerificationTypeModalContainer from './VerificationTypeModalContainer';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_VERIFICATION_TYPES } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  const handleToggleModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <Fragment>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)} onToggleModal={handleToggleModal} showModal={showModal}>
        <HeaderLinks onToggleModal={handleToggleModal} showModal={showModal} onCloseModal={handleCloseModal} />
      </Portal>
      {showModal && (
        <VerificationTypeModalContainer
          onToggleModal={handleToggleModal}
          title={t('VerificationTypes.TestingApplicabilityFormula.Title')}
          onCloseModal={handleCloseModal}
        />
      )}
      <PermissionCheck authorizationCode={ADMIN_VERIFICATION_TYPES}>
        <VerificationTypeListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
